@if (getVisibility(title)) {
  <div class="col-md-12 underline margin-top-30"></div>
  <div class="col-md-12 clear-all content-sub-wrapper-new common margin-top-30">
    <div class="col-md-12 clear-all header">
      <div class="col-md-9 text-left padding-right-0 margin-bottom">
        @if (titleFlag === true) {
          <p class="line-height" id="{{getId(title)}}" class="inner-title">
            {{getTitle(title)}}&nbsp;&nbsp;
            <i class="icon icon-tick" aria-hidden="true"></i>
          </p>
        }
        @if (titleFlag === false) {
          <p class="line-height" id="{{getId(title)}}" class="inner-title">{{getTitle(title)}}
          </p>
        }
      </div>
      @if ((getId(title) === 'yourPersonalDetails' && registrationStatus && isEdit) || (getId(title) != 'yourPersonalDetails' && isEdit)) {
        <div class="col-md-3 text-right"
          >
          <button id="edit-btn-{{getId(title)}}" class="btn btn-secondary btn-sm Centre" type="button"
          (click)="gotoEdit(onClickGoTo)">{{reviewLabel}}</button>
        </div>
      }
    </div>
    @if ((productCode === 'C' || (productCode === 'H' && title != 'Your pension annuity options' ) || (productCode === 'G' && title != 'Your pension annuity options' ))  ) {
      <dl class="col-md-12 clear-all">
        @for (section of dataList; track section; let i = $index) {
          @if (getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)) {
            <dl class="row clear-all flex-container">
              <dt class="col-md-5 field flex-50">
                <small class="font-weight"
                id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </dt>
              <dd class="col-md-7 field flex-50">
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInput(title,
                  section.label, fieldValues[section.storeControlName],
                  fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                fieldValues,i,section.storeControlName)}}</small>
              </dd>
            </dl>
          }
      }
      @if (medicalConditionStaticMsg &&
        ((dependantMedicalConditionInfo &&
        title === cmsData1.yourDependantsMedicalConditions)
        || (medicalConditionInfo && title === cmsData1.yourMedicalConditions))) {
        <div class="col-md-12 margin-top-30 clear-all">
          <div class="col-md-12 bg-lightblue field">
            <small class="font-weight">
              {{medicalConditionStaticMsg}}
            </small>
          </div>
        </div>
      }
      @if (getId(title) === 'yourPersonalDetails' && !registrationStatus) {
        <div class="col-md-12 newUserLogin">
          <small class="font-weight">{{cmsData1.newUserReview}}</small>
        </div>
      }
    </dl>
  }
  @if (productCode === 'H' && title =='Your pension annuity options') {
    <dl class="col-md-12 clear-all">
      @for (section of ftrpDataList; track section; let i = $index) {
        @if (getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)) {
          <dl class="row clear-all flex-container">
            <dt class="col-md-5 field flex-50">
              <small class="font-weight"
              id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
            </dt>
            <dd class="col-md-7 field flex-50">
              <small
                id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInput(title,
                section.label, fieldValues[section.storeControlName],
                fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
              fieldValues,i,section.storeControlName)}}</small>
            </dd>
          </dl>
        }
    }
  </dl>
}
@if (productCode === 'G' && title =='Your pension annuity options') {
  <dl class="col-md-12 clear-all">
    @for (section of corpDataList; track section; let i = $index) {
      @if (getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)) {
        <div class="flex-container">
          <dt class="col-md-5 field flex-50">
            <small class="font-weight"
            id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
          </dt>
          <dd class="col-md-7 field flex-50">
            <small
              id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInput(title,
              section.label, fieldValues[section.storeControlName],
              fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
            fieldValues,i,section.storeControlName)}}</small>
          </dd>
        </div>
      }
    }
  </dl>
}
@if (storeName !== 'beneficiaryDetails' && storeName !== 'pensionSavings') {
  <div class="row"></div>
  <dl class="col-md-12 clear-all">
    @for (section of summmaryDataList; track section; let i = $index) {
      @if (getTitleFlag(section,title,fieldValues[section.storeControlName],fieldValues)) {
        @if (section.storeControlName!='lifeTimeAllowance') {
          <dl class="flex-container">
            <dt class="col-md-5 field flex-50">
              <small class="font-weight"
              id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
            </dt>
            <dd class="col-md-7 field flex-50">
              <small
                id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInputApply(title,
                section.label, fieldValues[section.storeControlName],
                fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
              fieldValues,i,section.storeControlName)}}</small>
            </dd>
          </dl>
        } @else {
          @if (showContentLabel) {
            <dl class="flex-container">
              <dt class="col-md-5 field flex-50">
                <small class="font-weight"
                id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
              </dt>
              <dd class="col-md-7 field flex-50">
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldValues[section.storeControlName]?formatInputApply(title,
                  section.label, fieldValues[section.storeControlName],
                  fieldValues): throwEmpty(fieldValues[section.storeControlName], section.label, title,
                fieldValues,i,section.storeControlName)}}</small>
              </dd>
            </dl>
          }
        }
      }
    }
  </dl>
} @else {
  @if (storeName == 'beneficiaryDetails' && fieldValues?.length == 0) {
    <p class="beneficiaryTitle">
      None selected
    </p>
  }
  @for (fieldVal of fieldValues; track fieldVal; let i = $index) {
    <div>
      @if (storeName == 'beneficiaryDetails') {
        <p class="beneficiaryTitle"> Beneficiary {{i+1}}</p>
      }
      <div class="row"></div>
      @for (section of summmaryDataList; track section; let i = $index) {
        @if (getTitleFlag(section,title,fieldVal[section.storeControlName],fieldValues)) {
          <div class="flex-container">
            <div class="col-md-5 field flex-50">
              <small class="font-weight"
              id="{{getId(title)}}-{{section.storeControlName}}-name">{{getLabel(section.label)}} :</small>
            </div>
            <div class="col-md-7 field flex-50">
              @if (section.label == 'Tax-free cash' && fieldVal['extTfcAmt'] && fieldVal['extTfcAmt']!==null &&
                fieldValues['extTfcAmt'] !== '0') {
                <small id="{{getId(title)}}-{{section.storeControlName}}-value"
                  >{{fieldVal['extTfcAmt']?formatInputApply(title,
                  section.label, fieldVal['extTfcAmt'],
                  fieldVal): throwEmpty(fieldVal['extTfcAmt'], section.label, title, fieldVal,i,'extTfcAmt')}}
                </small>
              } @else {
                <small
                  id="{{getId(title)}}-{{section.storeControlName}}-value">{{fieldVal[section.storeControlName]?formatInputApply(title,
                  section.label, fieldVal[section.storeControlName],
                  fieldVal):throwEmpty(fieldVal[section.storeControlName], section.label, title,
                  fieldVal,i,section.storeControlName)}}
                </small>
              }
            </div>
          </div>
        }
      }
    </div>
  }
}
</div>
}
@if (isLocked) {
  <app-modal [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
    (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
  </app-modal>
}